"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Jun 28 2018
 */

var immutable_1 = require("immutable");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");
/**
 * <p>
 * Price zone represents another grouping of sites, but it differs from group of sites (GoS).
 * Unlike GoS, the site cannot be situated within multiple price zone. Each price zone contains
 * both internal and competitors sites. Internal sites are determined by GoS, external sites
 * are determined explicitly.
 * </p>
 *
 * <p>
 * Price zone entity is very important for price optimization. Since LOG-6017, national zone can be also
 * used for price optimization. YDG treats the national zone specifically and there is no need to send it
 * within its training.
 * </p>
 *
 * @author JMe
 * @author JMr
 * @author Radek Beran
 */


var PriceZone =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceZone, _DomainObject_1$Domai);

  /**
   * Constructs price zone.
   *
   * @param id the internal id.
   * @param numericId This ID is intended for systems (e.g. Yieldigo) that need numeric IDs.
   * @param name
   * @param description
   * @param groupOfSitesId the id of group of sites
   * @param competitorSitesIds the list of ids of competitors sites
   * @param archived the flag indicating whether price zone is archived, default value is false
   * @param isNational the flag indicating whether price zone is for whole nation
   */
  function PriceZone(id, numericId, name, description, groupOfSitesId, competitorSitesIds, archived, isNational) {
    var _this;

    _classCallCheck(this, PriceZone);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceZone).call(this));
    _this.id = id;
    _this.numericId = numericId;
    _this.name = name;
    _this.description = description;
    _this.groupOfSitesId = groupOfSitesId;
    _this.competitorSitesIds = competitorSitesIds;
    _this.archived = archived;
    _this.isNational = isNational;
    return _this;
  }
  /**
   * Removes given competitor site from list of competitor's sites and returns new instance of price zone.
   *
   * @param competitorSiteId the id of competitor site to removal
   * @returns new instance of price zone without given competitor site
   */


  _createClass(PriceZone, [{
    key: "removeCompetitorSite",
    value: function removeCompetitorSite(competitorSiteId) {
      if (typeof this.competitorSitesIds !== 'object' || this.competitorSitesIds === null || this.competitorSitesIds.size === 0) {
        return this;
      }

      if (!this.competitorSitesIds.contains(competitorSiteId)) {
        return this;
      }

      return this.copy('competitorSitesIds', this.competitorSitesIds.remove(this.competitorSitesIds.findIndex(function (item) {
        return item === competitorSiteId;
      })));
    }
    /**
     * Adds given competitor site to list of competitor's sites and returns new instance of price zone.
     *
     * @param competitorSiteId the id of competitor site to removal
     * @returns new instance of price zone with given competitor site
     */

  }, {
    key: "addCompetitorSite",
    value: function addCompetitorSite(competitorSiteId) {
      if (!this.competitorSitesIds.contains(competitorSiteId)) {
        return this;
      }

      if (typeof this.competitorSitesIds !== 'object' || this.competitorSitesIds === null) {
        return this.copy('competitorSitesIds', immutable_1.List(competitorSiteId));
      }

      return this.copy('competitorSitesIds', this.competitorSitesIds.push(competitorSiteId));
    }
  }]);

  return PriceZone;
}(DomainObject_1.DomainObject);

exports.PriceZone = PriceZone;
/**
 * lookup sequence used in UI to retrieve all available group of sites for prize zone creation.
 */

PriceZone.GROUP_OF_SITES_ID_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.GroupOfSitesNewPriceZone;
/**
 * lookup sequence used in UI to retrieve price zones.
 */

PriceZone.PRICE_ZONES_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.PriceZone; // tslint:disable-next-line:member-ordering

PriceZone.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceZone.name);
  return {
    id: builder.id('id'),
    numericId: builder.num('numericId'),
    name: builder.str('name'),
    description: builder.opt(builder.str('description').withDescription({
      multiline: true
    })),
    groupOfSitesId: builder.lookup('groupOfSitesId', PriceZone.GROUP_OF_SITES_ID_LOOKUP),
    competitorSitesIds: builder.listOf(builder.id('competitorSitesIds')),
    archived: builder.bool('archived'),
    isNational: builder.bool('isNational')
  };
}();

PriceZone.EMPTY = new PriceZone(utils_1.Utils.VOID_ID, utils_1.Utils.VOID_NUMERIC_ID, '', null, '', immutable_1.List(), false, false);